import React, { useState, useEffect } from "react";
import { Autocomplete, Box, Modal, TextField, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Form, Formik } from "formik";

function LoadModal({ style, userCompanyLinkId, open, handleClose, loadOptions, handleLoad }) {
  const [options, setOptions] = useState(loadOptions);
  const handleSubmit = (data) => {
    if (data.funnel.id) {
      handleLoad(data.funnel.id);
      handleClose();
    }
  };

  useEffect(() => {
    const opts = loadOptions.reduce((result, option) => {
      const group =
        option.FK_Owner_user_companies_links_id === userCompanyLinkId
          ? "My conversion funnels"
          : "Shared with me";
      const opt = { group, ...option };

      if (group === "My conversion funnels") {
        result.unshift(opt);
      } else {
        result.push(opt);
      }

      return result;
    }, []);

    setOptions(opts);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h4" sx={{ mb: "1rem" }}>
          Open Conversion Funnel
        </Typography>
        <Formik
          enableReinitialize
          validateOnChange
          onSubmit={handleSubmit}
          initialValues={{ funnel: null }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Autocomplete
                options={options}
                groupBy={(option) => option.group}
                getOptionLabel={(option) => option.title}
                value={
                  (values.funnel?.id && options.find((option) => option.id === values.funnel.id)) ||
                  null
                }
                sx={{ width: "100%" }}
                onChange={(_, value) => setFieldValue("funnel", value)}
                renderInput={(params) => <TextField {...params} label="Conversion Funnel" />}
              />
              <MDBox mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton onClick={handleClose} color="gray80" style={{ marginRight: "10px" }}>
                  Cancel
                </MDButton>
                <MDButton type="submit" color="primaryRed">
                  Open
                </MDButton>
              </MDBox>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default LoadModal;
